import { useEffect } from "react";

const SITE_URL = "https://theperfectbreak.co.uk";

function upsert(selector, create) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  return el;
}

export function Seo({ title, description, path = "/", jsonLd, noindex = false }) {
  useEffect(() => {
    document.title = title;
    const meta = (sel, make) => upsert(sel, make);
    meta('meta[name="description"]', () => {
      const m = document.createElement("meta");
      m.setAttribute("name", "description");
      return m;
    }).setAttribute("content", description);
    meta('meta[name="robots"]', () => {
      const m = document.createElement("meta");
      m.setAttribute("name", "robots");
      return m;
    }).setAttribute("content", noindex ? "noindex,follow" : "index,follow");
    meta('link[rel="canonical"]', () => {
      const l = document.createElement("link");
      l.setAttribute("rel", "canonical");
      return l;
    }).setAttribute("href", `${SITE_URL}${path}`);
    meta('meta[property="og:title"]', () => {
      const m = document.createElement("meta");
      m.setAttribute("property", "og:title");
      return m;
    }).setAttribute("content", title);
    meta('meta[property="og:description"]', () => {
      const m = document.createElement("meta");
      m.setAttribute("property", "og:description");
      return m;
    }).setAttribute("content", description);
    meta('meta[property="og:url"]', () => {
      const m = document.createElement("meta");
      m.setAttribute("property", "og:url");
      return m;
    }).setAttribute("content", `${SITE_URL}${path}`);

    const scripts = [];
    if (jsonLd) {
      const blocks = Array.isArray(jsonLd) ? jsonLd : [jsonLd];
      blocks.forEach((data) => {
        const s = document.createElement("script");
        s.type = "application/ld+json";
        s.dataset.seoJsonld = "true";
        s.textContent = JSON.stringify(data);
        document.head.appendChild(s);
        scripts.push(s);
      });
    }
    return () => scripts.forEach((s) => s.remove());
  }, [title, description, path, noindex, jsonLd]);
  return null;
}

export const ORG_JSONLD = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "The Perfect Break",
  url: SITE_URL,
  description:
    "Great-value UK short breaks for adults, combining hand-picked hotels with memorable experiences.",
  brand: { "@type": "Brand", name: "The Perfect Break" },
};

export const breadcrumbLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: item.name,
    item: `${SITE_URL}${item.path}`,
  })),
});

export const faqLd = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});
